<vnm-email-address *ngIf="user?.email" [email]="user?.email" [showIcon]="showIcons" [enableLink]="enableLinks"></vnm-email-address>
<vnm-phone-number *ngIf="user?.mobileNumber" [number]="user?.mobileNumber" [showIcon]="showIcons" [enableLink]="enableLinks"></vnm-phone-number>
